'use strict';

angular.module('TurneroApp').component('coTrsTurnoView', {
    bindings: {
    	ctrlPadre: '<',
    	idTurno: '<',
		mostrarUrl:'<'
    },
    controller: [
         'utilsService',
         'TurneroAppConstant',
         'TRSService',
         function (utilsService, TurneroAppConstant, TRSService) {
             var ctrl = this;


             ctrl.$onChanges = function () {
             	if (ctrl.idTurno) {
             		TRSService.Get_Tasas_Turno({ 'id_turno': ctrl.idTurno }).$promise.then(function (resultado) {
             			ctrl.tasasTurno = resultado.Data;
             			ctrl.ctrlPadre.TieneTasasRetributiva = ctrl.tasasTurno.length ? true : false;
             		}).catch(function (error) {
             			utilsService.errores(error);
             		});
             	}
             }

             ctrl.PagarTasa = function (campo,event) {
             	var url = TurneroAppConstant.TRS_Server.url + campo.Hash_Trx + '/' + campo.Id_Transaccion;
					window.open(url, '_blank');
             }

         }],
    template: require('./trsTurnoView.html')
});



// WEBPACK FOOTER //
// ./app/components/trs/trsTurnoViewComponent.js